import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Vote from "./pages/vote";
import Display from "./pages/display";

function App() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vote" element={<Vote />} />
            <Route path="/display" element={<Display />} />
        </Routes>
    );
}

export default App;
